export var DialogMode;
(function (DialogMode) {
    DialogMode[DialogMode["DeleteScenario"] = 0] = "DeleteScenario";
    DialogMode[DialogMode["RenameScenario"] = 1] = "RenameScenario";
    DialogMode[DialogMode["SwitchScenario"] = 2] = "SwitchScenario";
    DialogMode[DialogMode["RenameAfterSwitch"] = 3] = "RenameAfterSwitch";
    DialogMode[DialogMode["RenameFinancial"] = 4] = "RenameFinancial";
    DialogMode[DialogMode["HeadcountChange"] = 5] = "HeadcountChange";
    DialogMode[DialogMode["Multiskill"] = 6] = "Multiskill";
    DialogMode[DialogMode["MultiskillDelete"] = 7] = "MultiskillDelete";
    DialogMode[DialogMode["DeleteAllMultiskill"] = 8] = "DeleteAllMultiskill";
    DialogMode[DialogMode["LockPlan"] = 9] = "LockPlan";
})(DialogMode || (DialogMode = {}));
export var ConstraintType;
(function (ConstraintType) {
    ConstraintType["DefQueue"] = "defQueue";
    ConstraintType["NonDefQueue"] = "nonDefQueue";
    ConstraintType["Multiskill"] = "multiSkill";
    ConstraintType["Both"] = "both";
})(ConstraintType || (ConstraintType = {}));
